
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcParaDialog extends Serenity.EntityDialog<IcParaRow, any> {
        protected getFormKey() { return IcParaForm.formKey; }
        protected getIdProperty() { return IcParaRow.idProperty; }
        protected getLocalTextPrefix() { return IcParaRow.localTextPrefix; }
        protected getNameProperty() { return IcParaRow.nameProperty; }
        protected getService() { return IcParaService.baseUrl; }
        protected getDeletePermission() { return IcParaRow.deletePermission; }
        protected getInsertPermission() { return IcParaRow.insertPermission; }
        protected getUpdatePermission() { return IcParaRow.updatePermission; }

        protected form = new IcParaForm(this.idPrefix);

        constructor() {
            super();
            this.form.IcFg.changeSelect2(e => {
                // this.icfgp();
                // console.log(Q.toId(this.form.EndBillPmType.value))

                
            });
            
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close::after"), 1);

            
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // this.icfgp()
            this.deleteButton.hide();
            this.saveAndCloseButton.hide();
            
            // this.cloneButton.hide();

        }

        // private icfgp(){
        //     let Fg = Q.toId(this.form.IcFg.value)
        //     if (Fg == 'I') {
        //         // Serenity.EditorUtils.setReadOnly(this.form.PostSequenceFg, true);
        //         this.form.PostSequenceFg.value = "1"
        //     }else{
        //         Serenity.EditorUtils.setReadOnly(this.form.PostSequenceFg, false);
                
        //     }

        // }

    }
}